<script lang="ts" setup>
import { SysarbColors } from '@/types';
import type { PropType } from 'vue';
import { computed } from 'vue';
/**********
 * Init
 **********/

const props = defineProps({
    icon: {
        type: String,
        default: 'user'
    },
    iconColor: {
        type: String as PropType<SysarbColors>,
        default: SysarbColors.WHITE
    },
    primaryColor: {
        type: String as PropType<SysarbColors>,
        default: SysarbColors.GREEN_500
    },
    filled: {
        type: Boolean,
        default: true
    },
    size: {
        type: String as PropType<'small' | 'medium' | 'large'>,
        default: 'small'
    }
});

const containerColor = computed(() => (props.filled ? 'background' : 'border'));
</script>

<template>
    <div :class="['sy-badge-container display-inline-block', size]" :style="`${containerColor}-color: ${primaryColor}`">
        <Icon :icon="icon" :class="['sy-badge-icon flex-container', size]" :style="`color: ${filled ? iconColor : primaryColor}`" />
    </div>
</template>

<style scoped lang="scss">

.sy-badge-container {
    // This is here cause safari for some wierd reason treats a div as a paragraph....
    line-height: .9;

    border-radius: var(--sy-border-radius-pill);
    border-width: 2px;
    padding: var(--sy-spacer-2);

    border-style: solid;
    border-color: transparent;

    &.small {
        padding: 4px 4px;
    }

    &.medium {
        padding: 6px 6px;
    }

    &.large {
        padding: 8px 8px;
    }
}

.sy-badge-icon {
    &.small {
        width: 12px;
        height: 12px;
        stroke-width: 3px;
    }

    &.medium {
        width: 20px;
        height: 20px;
    }

    &.large {
        width: 28px;
        height: 28px;
    }
}
</style>
